import { Action as ReduxAction } from 'redux'
import {
    FETCH_CART_REQUEST,
    FETCH_CART_SUCCESS,
    FETCH_CART_ERROR,
    UPDATE_LINE_ITEM_REQUEST,
    UPDATE_LINE_ITEM_SUCCESS,
    UPDATE_LINE_ITEM_IN_BASKET_ERROR,
} from '../constants/ActionTypes'

export type IsFetchingCartAction = ReduxAction<
    | typeof FETCH_CART_REQUEST
    | typeof FETCH_CART_SUCCESS
    | typeof FETCH_CART_ERROR
    | typeof UPDATE_LINE_ITEM_REQUEST
    | typeof UPDATE_LINE_ITEM_SUCCESS
    | typeof UPDATE_LINE_ITEM_IN_BASKET_ERROR
>

const isFetchingCart = (state = false, action: IsFetchingCartAction) => {
    switch (action.type) {
        case FETCH_CART_REQUEST:
        case UPDATE_LINE_ITEM_REQUEST:
            return true

        case FETCH_CART_SUCCESS:
        case UPDATE_LINE_ITEM_SUCCESS:
        case UPDATE_LINE_ITEM_IN_BASKET_ERROR:
        case FETCH_CART_ERROR:
            return false

        default:
            return state
    }
}

export default isFetchingCart
